import { Component, OnInit, Input } from '@angular/core';
import { TimeZoneService } from 'src/app/services/timezone.service';
import {LocationStrategy} from '@angular/common';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements OnInit {
  @Input('image') image;
  @Input('title') title;
  @Input('titleAuckland') titleAuckland;
  @Input('titleIreland') titleIreland;
  @Input('titleUsaCanada') titleUsaCanada;
  @Input('blurb') blurb;
  @Input('blurbIreland') blurbIreland;
  @Input('underTitle') underTitle;
  @Input('webLink') webLink;
  @Input('buttonText') buttonText;
  @Input('buttonLink') buttonLink;

  // TimeZone related configuration
  public DefaultTimeZone:boolean = true;
  public AucklandTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;
  public USATimeZone:boolean = false;
  public aboutPage:boolean = false;

  constructor(private timezoneService: TimeZoneService, private url:LocationStrategy) {}

  ngOnInit() {
    // Check the timeZone
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();

      if(this.url.path()==='/about'){
         this.aboutPage=true; 
      }
    }

}
